__turbopack_context__.v({
  "actionBlock": "OfferView-module-scss-module__XOCKMG__actionBlock",
  "bottom-content": "OfferView-module-scss-module__XOCKMG__bottom-content",
  "bottom-info-item": "OfferView-module-scss-module__XOCKMG__bottom-info-item",
  "bottom-info-wrapper": "OfferView-module-scss-module__XOCKMG__bottom-info-wrapper",
  "bottom-right": "OfferView-module-scss-module__XOCKMG__bottom-right",
  "btn-ask": "OfferView-module-scss-module__XOCKMG__btn-ask",
  "btn-box": "OfferView-module-scss-module__XOCKMG__btn-box",
  "btn-close": "OfferView-module-scss-module__XOCKMG__btn-close",
  "btn-favorite": "OfferView-module-scss-module__XOCKMG__btn-favorite",
  "btn-left": "OfferView-module-scss-module__XOCKMG__btn-left",
  "btn-right": "OfferView-module-scss-module__XOCKMG__btn-right",
  "btn-wrapper": "OfferView-module-scss-module__XOCKMG__btn-wrapper",
  "btns": "OfferView-module-scss-module__XOCKMG__btns",
  "closeBtn": "OfferView-module-scss-module__XOCKMG__closeBtn",
  "deleteBtn": "OfferView-module-scss-module__XOCKMG__deleteBtn",
  "deleteModalBtns": "OfferView-module-scss-module__XOCKMG__deleteModalBtns",
  "editBtn": "OfferView-module-scss-module__XOCKMG__editBtn",
  "first-text": "OfferView-module-scss-module__XOCKMG__first-text",
  "fullWidth": "OfferView-module-scss-module__XOCKMG__fullWidth",
  "info-title-wrapper": "OfferView-module-scss-module__XOCKMG__info-title-wrapper",
  "isFavorite": "OfferView-module-scss-module__XOCKMG__isFavorite",
  "map-link": "OfferView-module-scss-module__XOCKMG__map-link",
  "middle-info": "OfferView-module-scss-module__XOCKMG__middle-info",
  "modal": "OfferView-module-scss-module__XOCKMG__modal",
  "modal-id": "OfferView-module-scss-module__XOCKMG__modal-id",
  "modal-title": "OfferView-module-scss-module__XOCKMG__modal-title",
  "modal-title-wrapper": "OfferView-module-scss-module__XOCKMG__modal-title-wrapper",
  "myAdverismentActionBlock": "OfferView-module-scss-module__XOCKMG__myAdverismentActionBlock",
  "noImage": "OfferView-module-scss-module__XOCKMG__noImage",
  "price-wrapper": "OfferView-module-scss-module__XOCKMG__price-wrapper",
  "proposeModal": "OfferView-module-scss-module__XOCKMG__proposeModal",
  "slider-item": "OfferView-module-scss-module__XOCKMG__slider-item",
  "slider-item-modal": "OfferView-module-scss-module__XOCKMG__slider-item-modal",
  "slider-modal": "OfferView-module-scss-module__XOCKMG__slider-modal",
  "status-wrapper": "OfferView-module-scss-module__XOCKMG__status-wrapper",
  "table": "OfferView-module-scss-module__XOCKMG__table",
  "table-item": "OfferView-module-scss-module__XOCKMG__table-item",
  "table-left": "OfferView-module-scss-module__XOCKMG__table-left",
  "table-right": "OfferView-module-scss-module__XOCKMG__table-right",
  "table-wrapper": "OfferView-module-scss-module__XOCKMG__table-wrapper",
  "tech-wrapper": "OfferView-module-scss-module__XOCKMG__tech-wrapper",
  "text": "OfferView-module-scss-module__XOCKMG__text",
  "tooltip-price": "OfferView-module-scss-module__XOCKMG__tooltip-price",
  "tooltip-status": "OfferView-module-scss-module__XOCKMG__tooltip-status",
  "top-content": "OfferView-module-scss-module__XOCKMG__top-content",
  "top-info": "OfferView-module-scss-module__XOCKMG__top-info",
  "top-modal": "OfferView-module-scss-module__XOCKMG__top-modal",
  "top-right": "OfferView-module-scss-module__XOCKMG__top-right",
  "viewedLike-wrapper": "OfferView-module-scss-module__XOCKMG__viewedLike-wrapper",
  "wrapper": "OfferView-module-scss-module__XOCKMG__wrapper",
});
